import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateSpiralPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  return starsData.map((star) => ({
    x: Math.cos(star.spiralData.angle) * star.spiralData.distance,
    y: star.spiralData.baseY,
    z: Math.sin(star.spiralData.angle) * star.spiralData.distance,
  }));
};
